import { useEffect, useState } from "react";
import { UserCheck, AlertTriangle } from "lucide-react";
import { api } from "../lib/api";

export const NameSuggestions = ({ convocationId, nom, prenom, onPick }) => {
  const [list, setList] = useState([]);
  const [convoque, setConvoque] = useState(null);
  const [focus, setFocus] = useState("");
  const q = (focus === "prenom" ? prenom : nom).trim();

  useEffect(() => {
    if (!convocationId || q.length < 3) { setList([]); return undefined; }
    const t = setTimeout(() => {
      api.get("/suggestions", { params: { c: convocationId, q } }).then((r) => setList(Array.isArray(r.data) ? r.data : [])).catch(() => setList([]));
    }, 300);
    return () => clearTimeout(t);
  }, [convocationId, q]);

  useEffect(() => {
    if (!convocationId || nom.trim().length < 2 || prenom.trim().length < 2) { setConvoque(null); return undefined; }
    const t = setTimeout(() => {
      api.get("/verif-nom", { params: { c: convocationId, nom, prenom } }).then((r) => setConvoque(r.data?.convoque ?? null)).catch(() => setConvoque(null));
    }, 700);
    return () => clearTimeout(t);
  }, [convocationId, nom, prenom]);

  useEffect(() => {
    const onFocus = (e) => {
      const id = e.target?.dataset?.testid;
      if (id === "convocation-form-nom-input") setFocus("nom");
      else if (id === "convocation-form-prenom-input") setFocus("prenom");
    };
    document.addEventListener("focusin", onFocus);
    return () => document.removeEventListener("focusin", onFocus);
  }, []);

  const exact = list.some((j) => j.nom.toLowerCase() === nom.trim().toLowerCase() && j.prenom.toLowerCase() === prenom.trim().toLowerCase());
  return (
    <div className="col-span-2 -mt-1 space-y-2">
      {list.length > 0 && !exact && (
        <div data-testid="name-suggestions" className="rounded-2xl border border-lime/50 bg-ink p-2">
          <p className="px-2 pb-1 text-xs text-dim">C'est toi ? Touche ton nom :</p>
          <div className="flex flex-wrap gap-2">
            {list.map((j, i) => (
              <button key={`${j.nom}-${j.prenom}`} type="button" data-testid={`name-suggestion-${i}`} onClick={() => { onPick(j); setList([]); }}
                className="inline-flex items-center gap-1.5 rounded-full border border-line px-3 py-1.5 text-sm text-chalk transition-colors hover:border-lime hover:text-lime">
                <UserCheck className="h-4 w-4 text-lime" />{j.prenom} {j.nom.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      )}
      {convoque === false && (
        <p data-testid="name-not-found-warning" role="alert" className="flex items-start gap-2 rounded-2xl border border-signal bg-signal/15 p-3 text-sm text-chalk">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-signal" />
          Nom introuvable dans la liste des convoqués : vérifie l'orthographe. Tu peux quand même envoyer ta réponse, le coach sera prévenu.
        </p>
      )}
    </div>
  );
};
